import React from 'react';
import { useStyles } from './styles';
import { Box, Container, Grid, Typography, Divider, Button } from '@mui/material';
import LazyLoad from 'react-lazyload';
import { useRouter } from 'next/router';
import useIsMobile from 'hooks/useIsMobile';
import { flowTrialActive } from 'utils';

export default function CheckBenefits() {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const router = useRouter();

  return (
    <Box bgcolor="#5F29CC">
      <Container>
        <LazyLoad offset={100}>
          <Box py={4}>
            <Typography className={classes.title} align="center" component="h2">
              <b>Check the main subscription benefits</b>
            </Typography>
          </Box>

          <Box px={!isMobile ? 30 : 0} pb={6}>
            <Grid container={true} spacing={3} justifyContent="center" alignItems="center">
              <Grid item={true} xs={12} md={4} align="center">
                <div className={classes.benefitBox}>
                  <img
                    src="/images/benefits/unlimited-illustrations-icon.svg"
                    alt=""
                    loading="lazy"
                  />

                  <Divider />

                  <Typography>
                    <b>
                      Unlimited <br /> Scientific <br /> Illustrations
                    </b>
                  </Typography>
                </div>
              </Grid>

              <Grid item={true} xs={12} md={4} align="center">
                <div className={classes.benefitBox}>
                  <img src="/images/benefits/high-definition-icon.svg" alt="" loading="lazy" />

                  <Divider />

                  <Typography>
                    <b>
                      High definition <br /> downloads
                    </b>
                  </Typography>
                </div>
              </Grid>

              <Grid item={true} xs={12} md={4} align="center">
                <div className={classes.benefitBox}>
                  <img src="/images/benefits/editable-figure-icon.svg" alt="" loading="lazy" />

                  <Divider />

                  <Typography>
                    <b>
                      Unlimited <br /> Editable <br /> Figures
                    </b>
                  </Typography>
                </div>
              </Grid>

              <Grid item={true} xs={12} md={4} align="center">
                <div className={classes.benefitBox}>
                  <img src="/images/benefits/free-templates-icon.svg" alt="" loading="lazy" />

                  <Divider />

                  <Typography>
                    <b>
                      Unlimited <br /> Free use of <br /> Templates
                    </b>
                  </Typography>
                </div>
              </Grid>

              <Grid item={true} xs={12} md={4} align="center">
                <div className={classes.benefitBox}>
                  <img
                    src="/images/benefits/customized-illustrations-icon.svg"
                    alt=""
                    loading="lazy"
                  />

                  <Divider />

                  <Typography>
                    <b>
                      Customized <br /> illustrations
                    </b>
                  </Typography>
                </div>
              </Grid>

              <Grid item={true} xs={12} md={4} align="center">
                <div className={classes.benefitBox}>
                  <img src="/images/benefits/slides-presentations-icon.svg" alt="" loading="lazy" />

                  <Divider />

                  <Typography>
                    <b>
                      Slides and <br /> Presentations <br /> feature
                    </b>
                  </Typography>
                </div>
              </Grid>
            </Grid>

            <Box display="flex" justifyContent="center" pt={6}>
              <Button
                onClick={() => router.push(flowTrialActive ? '/pricing-alt' : '/pricing')}
                className={classes.button}
              >
                Learn more about the subscription plans
              </Button>
            </Box>
          </Box>
        </LazyLoad>
      </Container>
    </Box>
  );
}
